import axios from "axios";
import authHeader from "./auth-header";
import {API_URL} from "./api-uri";

const getCenters = () => {
  return axios
    .get(API_URL + "Centers", { headers: authHeader() })
    .then((response) => {
      return response.data;
    }).catch((err) => {
    });
};

const upsertCenter = (center) => {
  return axios
    .put(API_URL + "Centers/UpsertCenter/" + center.id, center)
    .then((response) => {
      return response.data;
    }).catch((err) => {
      console.log(err)
    });
};

const deleteCenter = (id_center) => {
  return axios.delete(API_URL + "Centers/" + id_center).then(() => { return });
};

export default {
  getCenters,
  upsertCenter,
  deleteCenter
};